"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _createForOfIteratorHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createForOfIteratorHelper"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));
var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createSuper"));
var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/get"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/getPrototypeOf"));
var _react = _interopRequireDefault(require("react"));
require("./MusicEditor.css");
var _MusicUtil = require("./MusicUtil");
var _MusicEditor3 = _interopRequireDefault(require("./MusicEditor"));
var DEBUG = false;
function objectFlip(obj) {
  var ret = {};
  Object.keys(obj).forEach(function (key) {
    ret[obj[key]] = key;
  });
  return ret;
}
var voices = ["S", "A", "T", "B"];
var splitNotation = console.error;
var VoiceEditor = exports.default = /*#__PURE__*/function (_MusicEditor) {
  (0, _inherits2.default)(VoiceEditor, _MusicEditor);
  var _super = (0, _createSuper2.default)(VoiceEditor);
  function VoiceEditor(props) {
    var _thisSuper, _thisSuper2, _thisSuper3, _thisSuper4, _thisSuper5, _thisSuper6, _this;
    (0, _classCallCheck2.default)(this, VoiceEditor);
    _this = _super.call(this, props);
    _this.state = {
      // width: 300,
      accidental: "",
      duration: undefined,
      cursorNote: 0,
      cursorPitch: 0,
      editorActive: false,
      editorLabel: "music editor",
      voice: _this.props.startingVoice || "S"
    };
    // Inherited functions
    _this.generatePlaybackNotation = (0, _get2.default)((_thisSuper = (0, _assertThisInitialized2.default)(_this), (0, _getPrototypeOf2.default)(VoiceEditor.prototype)), "generatePlaybackNotation", _thisSuper).bind((0, _assertThisInitialized2.default)(_this));
    _this.renderNotation = (0, _get2.default)((_thisSuper2 = (0, _assertThisInitialized2.default)(_this), (0, _getPrototypeOf2.default)(VoiceEditor.prototype)), "renderNotation", _thisSuper2).bind((0, _assertThisInitialized2.default)(_this));
    _this.handleInput = (0, _get2.default)((_thisSuper3 = (0, _assertThisInitialized2.default)(_this), (0, _getPrototypeOf2.default)(VoiceEditor.prototype)), "handleInput", _thisSuper3).bind((0, _assertThisInitialized2.default)(_this));
    _this.updateCurrentHotspot = (0, _get2.default)((_thisSuper4 = (0, _assertThisInitialized2.default)(_this), (0, _getPrototypeOf2.default)(VoiceEditor.prototype)), "updateCurrentHotspot", _thisSuper4).bind((0, _assertThisInitialized2.default)(_this));
    _this.updatePreviousHotspot = (0, _get2.default)((_thisSuper5 = (0, _assertThisInitialized2.default)(_this), (0, _getPrototypeOf2.default)(VoiceEditor.prototype)), "updatePreviousHotspot", _thisSuper5).bind((0, _assertThisInitialized2.default)(_this));
    _this.playButton = (0, _get2.default)((_thisSuper6 = (0, _assertThisInitialized2.default)(_this), (0, _getPrototypeOf2.default)(VoiceEditor.prototype)), "playButton", _thisSuper6).bind((0, _assertThisInitialized2.default)(_this));
    // Own functions
    _this.updateWidth = _this.updateWidth.bind((0, _assertThisInitialized2.default)(_this));
    _this.callback = _this.callback.bind((0, _assertThisInitialized2.default)(_this));
    _this.findNoteByIndex = _this.findNoteByIndex.bind((0, _assertThisInitialized2.default)(_this));
    _this.updateSRLabel = _this.updateSRLabel.bind((0, _assertThisInitialized2.default)(_this));
    _this.updateHotspotsByVoice = _this.updateHotspotsByVoice.bind((0, _assertThisInitialized2.default)(_this));
    _this.updateHotspotsForCorrect = _this.updateHotspotsForCorrect.bind((0, _assertThisInitialized2.default)(_this));
    _this.highlightCorrectHotspots = _this.highlightCorrectHotspots.bind((0, _assertThisInitialized2.default)(_this));
    _this.describePitchClass = _this.describePitchClass.bind((0, _assertThisInitialized2.default)(_this));
    _this.ref = /*#__PURE__*/_react.default.createRef();
    _this.tab = null;
    return _this;
  }
  (0, _createClass2.default)(VoiceEditor, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener("resize", this.updateWidth);
      this.updateWidth();
      this.renderNotation();
      this.setState({
        duration: this.lastParse[0].multilineVars.default_length
      });
      var note = this.findNoteByIndex(0);
      if (note && note.hotspots) {
        var hotspot = note.hotspots["0"];
        if (hotspot) {
          hotspot.tabIndex = "0";
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener("resize", this.updateWidth);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevprops, prevstate, snapshot) {
      DEBUG && console.log("componentDidUpdate");
      var changed = false;
      for (var _i = 0, _Object$keys = Object.keys(this.props); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];
        if (this.props[key] !== prevprops[key]) {
          DEBUG && console.log("props.".concat(key, " changed"));
          changed = true;
        }
      }
      for (var _i2 = 0, _Object$keys2 = Object.keys(this.state); _i2 < _Object$keys2.length; _i2++) {
        var _key = _Object$keys2[_i2];
        if (this.state[_key] !== prevstate[_key]) {
          DEBUG && console.log("state.".concat(_key, " changed"));
          changed = true;
        }
      }
      if (changed) {
        this.renderNotation();
      }
      if (prevprops.round !== this.props.round) {
        this.setState({
          accidental: ""
        });
      }
      if (!prevprops.answer && this.props.answer) {
        var notationArray = this.props.notation.split('\n');

        // eslint-disable-next-line
        // this.state.accidental = ""
        // eslint-disable-next-line
        this.state.notationRound3 = {
          "s": splitNotation(notationArray[1]),
          "a": splitNotation(notationArray[3]),
          "t": splitNotation(notationArray[5]),
          "b": splitNotation(notationArray[7])
        };
      }
      if (this.props.answer && !this.props.correct && !this.props.reset) {
        if (this.state.voice !== prevstate.voice || this.props.submission_number !== prevprops.submission_number || this.props.notation !== prevprops.notation) {
          this.updateHotspotsForCorrect();
        }
      }
      this.updateHotspotsByVoice(this.state.voice);
      if (prevstate.width !== this.state.width || prevprops.notation !== this.props.notation || prevstate.cursorNote !== this.state.note || prevstate.cursorPitch !== this.state.pitch) {
        this.updatePreviousHotspot(prevstate);
        var note = this.findNoteByIndex(this.state.cursorNote);
        this.currentNote = note;
        if (prevstate.cursorNote !== this.state.cursorNote || prevstate.cursorPitch !== this.state.cursorPitch || prevprops.notation !== this.props.notation) {
          if (note) {
            this.updateSRLabel();
          }
        }
        if (note) {
          this.updateCurrentHotspot(note, prevstate);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this,
        _this$props$rangeUppe,
        _this$props$rangeLowe;
      return /*#__PURE__*/_react.default.createElement("div", {
        ref: this.ref,
        className: "music-editor",
        "aria-live": "polite"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "radio-toolbar top"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "icon-image-container",
        style: {
          width: "10%",
          textAlign: "left",
          float: "left"
        }
      }, this.props.musicButtonAudio && /*#__PURE__*/_react.default.createElement("button", {
        className: "action-button",
        ref: function ref(e) {
          _this2.play = e;
        },
        "aria-label": "Play",
        disabled: this.props.notation.trim() === "z",
        onClick: this.playButton,
        style: {
          display: "inline-block",
          height: "43px",
          width: "42px",
          padding: "0px"
        }
      }, this.state.playing && /*#__PURE__*/_react.default.createElement("img", {
        className: "icon-image",
        src: _MusicUtil.icons.play,
        alt: "pause"
      }), !this.state.playing && /*#__PURE__*/_react.default.createElement("img", {
        className: "icon-image",
        src: _MusicUtil.icons.pause,
        alt: "play"
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "radio-button-group",
        style: {
          display: "inline-block",
          width: "90%",
          textAlign: "right"
        }
      }, this.props.musicButtonSATB && this.renderVoiceButtons(), this.props.musicButtonAccidentals && this.renderAccidentalButtons())), /*#__PURE__*/_react.default.createElement("div", {
        ref: function ref(e) {
          _this2.container = e;
        },
        role: "grid",
        "aria-live": "off",
        "aria-colcount": this.numNotes,
        "aria-rowcount": ((_this$props$rangeUppe = this.props.rangeUpper) !== null && _this$props$rangeUppe !== void 0 ? _this$props$rangeUppe : 15) - ((_this$props$rangeLowe = this.props.rangeLower) !== null && _this$props$rangeLowe !== void 0 ? _this$props$rangeLowe : -3) + 1,
        style: !this.state.voice ? {
          pointerEvents: "none",
          minHeight: this.props.minHeight
        } : {
          minHeight: this.props.minHeight
        },
        onKeyDown: this.handleInput,
        onFocus: function onFocus() {
          _this2.setState({
            editorActive: true
          });
        },
        onBlur: function onBlur() {
          _this2.setState({
            editorActive: false
          });
        },
        onMouseLeave: function onMouseLeave() {
          _this2.setState({
            editorActive: false
          });
        }
      }), /*#__PURE__*/_react.default.createElement("div", {
        id: "desc",
        style: {
          width: "1px",
          height: "1px",
          overflow: "hidden"
        }
      }, "temporarily disabled"), this.state.keyboardControl && /*#__PURE__*/_react.default.createElement("span", {
        className: "hint"
      }, "You can use the arrow keys to navigate the editor."), this.props.durations && /*#__PURE__*/_react.default.createElement("div", {
        className: "toolbar bottom"
      }, /*#__PURE__*/_react.default.createElement("div", null), /*#__PURE__*/_react.default.createElement("div", null, Object.keys(_MusicUtil.durations).sort().map(function (frac) {
        return /*#__PURE__*/_react.default.createElement("button", {
          className: "duration",
          "aria-pressed": _this2.state.duration === Number(frac),
          id: frac,
          key: frac,
          "aria-label": _this2.describeNoteDuration(Number(frac)) + " note",
          onClick: function onClick() {
            _this2.setState({
              duration: frac
            });
          }
        }, _MusicUtil.durations[frac]);
      }))));
    }
  }, {
    key: "renderVoiceButtons",
    value: function renderVoiceButtons() {
      var _this3 = this;
      var active_voices = {
        "S": this.props.musicButtonSoprano,
        "A": this.props.musicButtonAlto,
        "T": this.props.musicButtonTenor,
        "B": this.props.musicButtonBass
      };
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "voice-buttons",
        style: {
          display: "inline-block",
          marginBottom: !this.areButtonsOnOneLine(this.props.musicStaffWidth) ? "5px" : ""
        },
        role: "radiogroup",
        "aria-label": "Select a voice"
      }, voices.map(function (voice) {
        return active_voices[voice] && /*#__PURE__*/_react.default.createElement("div", {
          className: "icon-image-container",
          key: voice
        }, /*#__PURE__*/_react.default.createElement("input", {
          className: "voice",
          type: "radio",
          name: "voice",
          id: voice,
          value: voice,
          "aria-label": voice,
          onChange: function onChange(e) {
            _this3.setState({
              voice: voice
            });
          },
          checked: _this3.state.voice === voice
        }), /*#__PURE__*/_react.default.createElement("label", {
          htmlFor: voice,
          key: voice
        }, /*#__PURE__*/_react.default.createElement("img", {
          className: "icon-image",
          src: _MusicUtil.icons[voice],
          alt: ""
        })));
      }), this.areButtonsOnOneLine(this.props.musicStaffWidth) && /*#__PURE__*/_react.default.createElement("div", {
        style: {
          position: "relative",
          height: "26px",
          display: "inline-block",
          marginLeft: "6px",
          marginRight: "3px"
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        style: {
          position: "relative",
          borderLeft: "1px solid black",
          height: "40px",
          top: "-10px"
        }
      })));
    }
  }, {
    key: "renderAccidentalButtons",
    value: function renderAccidentalButtons() {
      var _this4 = this;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "accidental-buttons",
        style: {
          display: "inline-block"
        },
        role: "radiogroup",
        "aria-label": "Apply an accidental"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "icon-image-container"
      }, /*#__PURE__*/_react.default.createElement("input", {
        type: "radio",
        name: "accidental",
        value: "none",
        id: "none",
        onChange: function onChange() {
          _this4.setState({
            accidental: ""
          });
        },
        checked: this.state.accidental === ""
      }), /*#__PURE__*/_react.default.createElement("label", {
        htmlFor: "none"
      }, /*#__PURE__*/_react.default.createElement("img", {
        className: "icon-image",
        src: _MusicUtil.icons.whole,
        alt: ""
      }))), Object.keys(_MusicUtil.accidentals).map(function (value, code) {
        return _this4.props[_MusicUtil.accidentals_to_props[value]] && /*#__PURE__*/_react.default.createElement("div", {
          className: "icon-image-container",
          key: value
        }, /*#__PURE__*/_react.default.createElement("input", {
          className: "accidental",
          type: "radio",
          name: "accidental",
          id: value,
          value: value,
          "aria-label": value,
          onChange: function onChange() {
            _this4.setState({
              accidental: _MusicUtil.accidentals[value]
            });
          },
          checked: _this4.state.accidental === _MusicUtil.accidentals[value],
          disabled: _this4.props.answer && !_this4.props.answer.includes(_MusicUtil.accidentals[value])
        }), /*#__PURE__*/_react.default.createElement("label", {
          htmlFor: value,
          key: value
        }, /*#__PURE__*/_react.default.createElement("img", {
          className: "icon-image",
          src: _MusicUtil.icons[value],
          alt: ""
        })));
      }));
    }
  }, {
    key: "callback",
    value: function callback(pitch, e, manual) {
      var offset = this.props.precursor ? this.props.precursor.length : 0;
      var oldNote = this.props.notation.substring(e.abcelem.startChar - offset, e.abcelem.endChar - offset);
      var hasOpeningTie = oldNote.includes('(');
      var hasClosingTie = oldNote.includes(')');
      var currentVoice = null;
      var clef = "";
      switch (this.state.voice) {
        case 'S':
          currentVoice = this.lastParse[0].lines[0].staff[0].voices[0];
          clef = 'treble';
          break;
        case 'A':
          currentVoice = this.lastParse[0].lines[0].staff[0].voices[1];
          clef = 'treble';
          break;
        case 'T':
          currentVoice = this.lastParse[0].lines[0].staff[1].voices[0];
          clef = 'bass';
          break;
        case 'B':
          currentVoice = this.lastParse[0].lines[0].staff[1].voices[1];
          clef = 'bass';
          break;
        default:
          return;
      }
      var i = 0;
      var new_note_start = 0;
      var new_note_end = 0;
      var _iterator = (0, _createForOfIteratorHelper2.default)(currentVoice),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var note = _step.value;
          // if (e.abcelem.notenumber === i && (note.el_type === "note" || note.el_type === "rest")) {
          if (e.abcelem.startChar === note.startChar && (note.el_type === "note" || note.el_type === "rest")) {
            var new_pitch = {
              pitch: pitch,
              verticalPos: pitch,
              accidental: _MusicUtil.accidentals_code[this.state.accidental]
            };
            if (note.pitches && note.pitches[0].startSlur) {
              new_pitch.startSlur = note.pitches[0].startSlur;
            }
            if (note.pitches && note.pitches[0].endSlur) {
              new_pitch.endSlur = note.pitches[0].endSlur;
            }
            // check how long the note is before doing anything
            var oldExtra = note.endChar - note.startChar - this.serializeNote(note, 0, clef).length;
            new_note_start = note.startChar;
            new_note_end = note.endChar;
            if (note.rest) {
              note.rest = undefined;
              note.pitches = [new_pitch];
            } else if (note.pitches) {
              if (this.props.monophonic) {
                if (note.pitches[0].pitch !== new_pitch.pitch && note.pitches[0].verticalPos !== new_pitch.pitch || note.pitches[0].accidental !== new_pitch.accidental) {
                  note.pitches = [new_pitch];
                } else {
                  note.rest = {
                    type: 'rest'
                  };
                  delete note.pitches;
                }
              } else {
                //console.log('not monophonic')
              }
            }
            oldNote = this.serializeNote(note, oldExtra, clef);
            this.setState({
              cursorNote: i,
              cursorPitch: pitch
            });
            break;
          }
          if (note.el_type === "note") ++i;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (new_note_start && new_note_end) {
        // console.log(new_note_start, oldNote, new_note_end)
        oldNote = (hasOpeningTie ? "(" : "") + oldNote + (hasClosingTie ? ")" : "");
        var newNotation = this.props.notation.substring(0, new_note_start - offset) + oldNote + this.props.notation.substring(new_note_end - offset);
        this.props.onChange(newNotation);
      }
    }
  }, {
    key: "updateWidth",
    value: function updateWidth() {
      if (this.state.width !== this.container.offsetWidth) this.setState({
        width: this.container.offsetWidth
      });
    }
  }, {
    key: "findNoteByIndex",
    value: function findNoteByIndex(index) {
      var ret;
      var currentVoice = null;
      switch (this.state.voice) {
        //only using top level hotspots (ie. A hotspots for S and A voice, B hotspots for T and B voice)
        case 'S':
          currentVoice = this.lastParse[0].lines[0].staff[0].voices[0];
          break;
        case 'A':
          currentVoice = this.lastParse[0].lines[0].staff[0].voices[1];
          break;
        case 'T':
          currentVoice = this.lastParse[0].lines[0].staff[1].voices[0];
          break;
        case 'B':
          currentVoice = this.lastParse[0].lines[0].staff[1].voices[1];
          break;
        default:
          return;
      }
      var i = 0;
      var _iterator2 = (0, _createForOfIteratorHelper2.default)(currentVoice),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var note = _step2.value;
          if (note.el_type === "note") {
            if (i === index) {
              ret = note;
            }
            ++i;
          }
          this.numNotes = i;
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return ret;
    }
  }, {
    key: "updateHotspotsForCorrect",
    value: function updateHotspotsForCorrect() {
      var index = voices.indexOf(this.state.voice);
      if (index === -1) return;
      var voiceNotes = this.props.answer.split(';').map(function (voice) {
        return splitNotation(voice);
      });
      var userNotes = this.state.notationRound3;
      var voice_num = 0;
      var _iterator3 = (0, _createForOfIteratorHelper2.default)(this.lastParse[0].lines),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var line = _step3.value;
          var _iterator4 = (0, _createForOfIteratorHelper2.default)(line.staff),
            _step4;
          try {
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              var staff = _step4.value;
              var _iterator5 = (0, _createForOfIteratorHelper2.default)(staff.voices),
                _step5;
              try {
                for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                  var voice = _step5.value;
                  if (this.props.voiceButtons[voice_num] === 'true') {
                    var note_num = 0;
                    var correctNotes = voiceNotes[voice_num];
                    var _iterator6 = (0, _createForOfIteratorHelper2.default)(voice),
                      _step6;
                    try {
                      for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
                        var note = _step6.value;
                        if (note.el_type === "note") {
                          if (correctNotes[note_num] === undefined) {
                            debugger;
                          }
                          var extractedNote = correctNotes[note_num].match(/[A-Z]'*,*/g);
                          var targetHotspot = void 0;
                          if (voice_num < 2) {
                            targetHotspot = (0, _MusicUtil.get_treble_pitch_number)(extractedNote);
                          } else {
                            targetHotspot = (0, _MusicUtil.get_bass_pitch_number)(extractedNote);
                          }
                          if (note.hotspots) {
                            var hotspot = note.hotspots[targetHotspot];
                            if (hotspot) this.highlightCorrectHotspots(correctNotes[note_num], userNotes["satb"[voice_num]][note_num], hotspot);
                          }
                          note_num++;
                        } else if (note.el_type === "bar") {
                          note_num++;
                        }
                      }
                    } catch (err) {
                      _iterator6.e(err);
                    } finally {
                      _iterator6.f();
                    }
                  }
                  voice_num++;
                }
              } catch (err) {
                _iterator5.e(err);
              } finally {
                _iterator5.f();
              }
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  }, {
    key: "highlightCorrectHotspots",
    value: function highlightCorrectHotspots(correctNote, userNote, hotspot) {
      var _this5 = this;
      if (correctNote.replace(/\s/g, "") === userNote.replace(/\s/g, "")) {
        hotspot.classList.add('green');
        hotspot.classList.remove('staff-space', 'staff-line');
      }
      if (this.props.submission_number > 3) {
        hotspot.classList.add('green');
        hotspot.classList.remove('staff-space', 'staff-line');
        var noteAccidental = this.extractNoteAccidental(correctNote);
        if (noteAccidental) {
          hotspot.classList.add('green');
          hotspot.classList.remove('staff-space', 'staff-line');
          hotspot.addEventListener('mouseenter', function (e) {
            // e.target.style["fill-opacity"] = 0.6;
            _this5.setState({
              accidental: _MusicUtil.accidentals[noteAccidental]
            });
          });
          hotspot.addEventListener('mouseleave', function (e) {
            // e.target.style["fill-opacity"] = 0.2;
            _this5.setState({
              accidental: ""
            });
          });
        } else {
          hotspot.addEventListener('mouseenter', function (e) {
            _this5.setState({
              accidental: ""
            });
          });
        }
      }
    }
  }, {
    key: "extractNoteAccidental",
    value: function extractNoteAccidental(note) {
      var acc = "";
      if (note.includes('^')) acc = "sharp";
      if (note.includes('_')) acc = "flat";
      if (note.includes('=')) acc = "natural";
      if (note.includes('^^')) acc = "dblsharp";
      if (note.includes('__')) acc = "dblflat";
      return acc;
    }
  }, {
    key: "updateHotspotsByVoice",
    value: function updateHotspotsByVoice(voice) {
      //clear out surrounding note boxes so that underlying hotspots can activate hover
      var notes = this.ref.current.getElementsByClassName('abcjs-note');
      for (var k = 0; k < notes.length; k++) {
        notes[k].nextElementSibling.style.pointerEvents = "none";
      }
      var voice_num = 0;
      var _iterator7 = (0, _createForOfIteratorHelper2.default)(this.lastParse[0].lines),
        _step7;
      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var line = _step7.value;
          var _iterator8 = (0, _createForOfIteratorHelper2.default)(line.staff),
            _step8;
          try {
            for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
              var staff = _step8.value;
              var _iterator9 = (0, _createForOfIteratorHelper2.default)(staff.voices),
                _step9;
              try {
                for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
                  var _voice = _step9.value;
                  var voice_name = voices[voice_num];
                  voice_num++;
                  var _iterator10 = (0, _createForOfIteratorHelper2.default)(_voice),
                    _step10;
                  try {
                    for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
                      var note = _step10.value;
                      if (note.el_type === "note") {
                        if (note.hotspots) {
                          for (var i = (_this$props$rangeLowe2 = this.props.rangeLower) !== null && _this$props$rangeLowe2 !== void 0 ? _this$props$rangeLowe2 : -3; i <= ((_this$props$rangeUppe2 = this.props.rangeUpper) !== null && _this$props$rangeUppe2 !== void 0 ? _this$props$rangeUppe2 : 15); ++i) {
                            var _this$props$rangeLowe2, _this$props$rangeUppe2;
                            var hotspot = note.hotspots["" + i];
                            if (voice_name === this.state.voice) {
                              hotspot.style.display = "";
                            } else {
                              hotspot.style.display = "none";
                            }
                          }
                        }
                      }
                    }
                  } catch (err) {
                    _iterator10.e(err);
                  } finally {
                    _iterator10.f();
                  }
                }
              } catch (err) {
                _iterator9.e(err);
              } finally {
                _iterator9.f();
              }
            }
          } catch (err) {
            _iterator8.e(err);
          } finally {
            _iterator8.f();
          }
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }
    }
  }, {
    key: "describePitchClass",
    value: function describePitchClass(j) {
      if (this.state.voice === 'S' || this.state.voice === 'A') {
        return (0, _MusicUtil.get_treble_pitch)(j);
      } else if (this.state.voice === 'T' || this.state.voice === 'B') {
        return (0, _MusicUtil.get_bass_pitch)(j);
      }
    }
  }, {
    key: "updateSRLabel",
    value: function updateSRLabel() {
      var label;
      var split_notation = this.props.notation.split('\n');
      label = "Soprano: " + split_notation[1] + " Alto: " + split_notation[3] + " Tenor: " + split_notation[5] + " Base: " + split_notation[7];
      var current;
      switch (this.state.voice) {
        case 'S':
          current = "selected pitch: " + (0, _MusicUtil.get_treble_pitch)(this.state.cursorPitch) + " on note " + (this.state.cursorNote + 1) + " on Soprano.";
          break;
        case 'A':
          current = "selected pitch: " + (0, _MusicUtil.get_treble_pitch)(this.state.cursorPitch) + " on note " + (this.state.cursorNote + 1) + " on Alto.";
          break;
        case 'T':
          current = "selected pitch: " + (0, _MusicUtil.get_bass_pitch)(this.state.cursorPitch) + " on note " + (this.state.cursorNote + 1) + " on Tenor.";
          break;
        case 'B':
          current = "selected pitch: " + (0, _MusicUtil.get_bass_pitch)(this.state.cursorPitch) + " on note " + (this.state.cursorNote + 1) + " on Bass.";
          break;
        default:
          current = "Please select a voice to make edits.";
          return;
      }
      this.setState({
        editorLabel: label + current
      });
    }
  }, {
    key: "noteCount",
    value: function noteCount(str) {
      return str.match(/[A-Za-z]/g).length;
    }
  }, {
    key: "areButtonsOnOneLine",
    value: function areButtonsOnOneLine(str) {
      if (this.ref.current) {
        if (this.ref.current.offsetWidth - 48 - this.ref.current.getElementsByClassName('accidental-buttons')[0].offsetWidth - this.ref.current.getElementsByClassName('voice-buttons')[0].offsetWidth < 0) {
          return false;
        } else {
          return true;
        }
      }
      // if(str.slice(-1) === "%"){
      //   if(parseInt(str.slice(0,-1)) < 58){
      //     return false;
      //   }
      // } else if(str.slice(-2) === "px"){
      //     if(parseInt(str.slice(0,-2)) < 381){
      //       return false;
      //     }
      // }
      // return true;
    }
  }]);
  return VoiceEditor;
}(_MusicEditor3.default);